import playForFunGame from '../entities/playForFunGame';
import playForRealGame from '../entities/playForRealGame';
import playFromCallback from '../entities/playFromCallback';
import { getSDKConfig } from '../shares/lib/getSDKConfig';
import logger from '../shares/lib/logger';
import { showError, hideLoader } from '../shares/lib/otpUtils';

const playGame = async () => {
  const swipeSDKConfig = getSDKConfig();
  try {
    const urlFromCallback = await playFromCallback(
      swipeSDKConfig?.swipeGames?.urlCallbackFn,
    );

    if (urlFromCallback) {
      return urlFromCallback;
    }

    if (swipeSDKConfig?.swipeGames?.playForFunMode) {
      logger.info('Playing game in fun mode');
      return await playForFunGame(swipeSDKConfig);
    } else {
      logger.info('Playing game in real mode');
      return await playForRealGame(swipeSDKConfig);
    }
  } catch (error) {
    const errorMessage =
      error instanceof Error
        ? error.message
        : 'Error while attempting to play game';
    logger.error('Error while attempting to play game', { error });
    hideLoader();
    showError(errorMessage, error);
    return null;
  }
};

export default playGame;
